import {
  getMyRoomsPageListOptimizeApi,
  getRoomsPageListApi,
  getTemplatesPageListOptimizeApi,
  getSortMyRoomsPageListOptimizeApi,
} from '../api/myprojects';
import { useMemo } from 'react';
import { useThumbnailCardDataList } from './useDataList';
import {
  paginatedRoomsActions,
  paginatedRoomsSelector,
} from '../redux/slicers/admin/paginatedRooms';
import { MODEL_TYPES } from '../constants/constants';
import { Recent_First_Value, Recent_First_Value_Created_At } from '../constants/filters';
import { selectIsCacheUsedInAPI } from '../redux/slicers/appSlicer';
import { getAppState } from '../redux/store';

export const useRooms = ({
  requestParams,
  filterByKey,
  defaultBrands,
  defaultSort = Recent_First_Value_Created_At, // '-created_at',
  defaultFilterBy,
  defaultCreatedBy,
  useGlobalSearch,
  skipBrandFilter,
  modelType = MODEL_TYPES.ROOM,
  api,
  useGlobalFilter,
  useRoomSortApi = false,
} = {}) => {
  // Read the cache-busting timestamp non-reactively so a notification-triggered
  // clearCacheFromAPI() doesn't cause this list to auto-refetch while mounted.
  // The latest value is picked up on the next mount (e.g. when the user
  // navigates back to the page), bypassing the cached response at that point.
  const requestParamsWithCache = useMemo(
    () => ({ ...(requestParams || {}), _cat: selectIsCacheUsedInAPI(getAppState()) }),
    [requestParams]
  );

  const data = useThumbnailCardDataList({
    selector: paginatedRoomsSelector,
    resetAction: paginatedRoomsActions.resetList,
    getAction:
      api || modelType === MODEL_TYPES.ROOM
        ? useRoomSortApi ? getSortMyRoomsPageListOptimizeApi : getMyRoomsPageListOptimizeApi
        : getTemplatesPageListOptimizeApi, // getRoomsPageListApi,
    itemDeleteText: 'Are you sure you want to delete this template?',
    itemsDeleteText: (selectedIds) =>
      `Are you sure you want to delete ${selectedIds.length} templates?`,
    requestParams: requestParamsWithCache,
    filterByKey,
    defaultBrands,
    defaultSort,
    defaultFilterBy,
    useGlobalFilter,
    hookName: 'useRooms',
    defaultCreatedBy,
    useGlobalSearch,
    skipBrandFilter,
    modelType,
    actions: paginatedRoomsActions
  });
  return data;
};
